import * as React from 'react';
import { SlideDown } from 'react-slidedown';
import SVGInline from 'react-svg-inline';
import * as classnames from 'classnames/bind';

import styles from './FaqItem.scss';
import arrow from '../../Icon/triangle-arrow.svg';
import { FaqLocale } from './faqItem.locale';

const cx = classnames.bind(styles);

interface FaqItemProps {
  locale: FaqLocale;
  toggleFaq: () => void;
  isLast: boolean;
  isOpened: boolean;
}

const FaqItem: React.SFC<FaqItemProps> = ({ locale, toggleFaq, isLast, isOpened }) => (
  <section className={styles.faqItem}>
    <div className={styles.questionContainer} onClick={toggleFaq}>
      <div>{locale.question}</div>
      <SVGInline svg={arrow} className={cx({ arrow: true, active: isOpened })} />
    </div>
    <SlideDown>
      {isOpened ? (
        <div className={styles.answer} dangerouslySetInnerHTML={{ __html: locale.answer }} />
      ) : null}
    </SlideDown>
    {!isLast && <div className={styles.delimiter} />}
  </section>
);

export default FaqItem;



// WEBPACK FOOTER //
// /www/client/src/components/FaqPage/FaqItem/FaqItem.tsx